
export default function RankingList() {
  const cards = [
    {
      rank: 1,
      name: '三井住友カード（NL）',
      image: 'https://public.readdy.ai/ai/img_res/dcadbf251899d199834b0f5abece307b.jpg',
      annualFee: '永年無料',
      returnRate: '0.5%〜7%',
      travelInsurance: '最大2,000万円（利用付帯）',
      lounge: '×',
      features: ['海外旅行傷害保険付帯', 'タッチ決済対応', '海外でも安心のVisa'],
      highlight: '年会費無料で海外旅行保険付き',
      badge: '初心者おすすめ',
      badgeColor: 'from-emerald-500 to-teal-500',
      href: '/mitsui',
    },
    {
      rank: 2,
      name: '大手ECモール系カード',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20red%20and%20white%20credit%20card%20with%20modern%20design%20on%20soft%20gradient%20background%20professional%20product%20photography%20clean%20aesthetic&width=300&height=190&seq=travel-card-2&orientation=landscape',
      annualFee: '永年無料',
      returnRate: '1.0%〜3.0%',
      travelInsurance: '最大2,000万円（利用付帯）',
      lounge: '×',
      features: ['海外旅行傷害保険付帯', 'ポイント高還元', '海外キャッシング対応'],
      highlight: 'ポイント還元率が高く旅行費用を節約',
      badge: '高還元率',
      badgeColor: 'from-rose-500 to-pink-500',
      href: '/rakuten',
    },
    {
      rank: 3,
      name: 'dカード GOLD U',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20gold%20credit%20card%20with%20premium%20design%20on%20soft%20gradient%20background%20professional%20product%20photography%20clean%20aesthetic&width=300&height=190&seq=travel-card-3&orientation=landscape',
      annualFee: '11,000円',
      returnRate: '1.0%〜10%',
      travelInsurance: '最大1億円（自動付帯）',
      lounge: '○（国内主要空港）',
      features: ['海外旅行保険自動付帯', '空港ラウンジ無料', 'dポイント高還元'],
      highlight: '充実の保険と空港ラウンジ利用可能',
      badge: '保険充実',
      badgeColor: 'from-amber-500 to-orange-500',
      href: '/dcard',
    },
    {
      rank: 4,
      name: 'JAカード',
      image: 'https://readdy.ai/api/search-image?query=Professional%20green%20credit%20card%20with%20agricultural%20theme%20on%20soft%20gradient%20background%20professional%20product%20photography%20clean%20aesthetic&width=300&height=190&seq=travel-card-4&orientation=landscape',
      annualFee: '1,375円',
      returnRate: '0.5%〜1.0%',
      travelInsurance: '最大3,000万円（自動付帯）',
      lounge: '×',
      features: ['海外旅行保険自動付帯', 'JA共済との連携', '海外アシスタンスサービス'],
      highlight: '自動付帯の海外旅行保険が魅力',
      badge: '自動付帯',
      badgeColor: 'from-green-500 to-emerald-500',
      href: '/ja',
    },
    {
      rank: 5,
      name: 'リクルートカード',
      image: 'https://readdy.ai/api/search-image?query=Modern%20blue%20credit%20card%20with%20sleek%20design%20on%20soft%20gradient%20background%20professional%20product%20photography%20clean%20aesthetic&width=300&height=190&seq=travel-card-5&orientation=landscape',
      annualFee: '永年無料',
      returnRate: '1.2%',
      travelInsurance: '最大2,000万円（利用付帯）',
      lounge: '×',
      features: ['業界最高水準の還元率', '海外旅行傷害保険付帯', 'Pontaポイント交換可能'],
      highlight: '年会費無料で還元率1.2%の高還元',
      badge: '還元率No.1',
      badgeColor: 'from-sky-500 to-cyan-500',
      href: '/recruit',
    },
  ];

  return (
    <section id="ranking" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block bg-gradient-to-r from-sky-100 to-cyan-100 text-sky-700 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold mb-4">
            ✈️ 海外旅行向けランキング
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            海外旅行におすすめの
            <br className="sm:hidden" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">クレジットカード</span>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            海外旅行保険、空港ラウンジ、海外キャッシングなど、旅行に便利な機能を重視して厳選
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8">
          {cards.map((card) => (
            <div
              key={card.rank}
              className="relative bg-white rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              {/* ランキングバッジ */}
              <div className={`absolute top-0 left-0 w-16 h-16 sm:w-20 sm:h-20 ${card.rank === 1 ? 'bg-gradient-to-br from-amber-400 to-yellow-500' : card.rank === 2 ? 'bg-gradient-to-br from-gray-300 to-gray-400' : card.rank === 3 ? 'bg-gradient-to-br from-amber-600 to-amber-700' : 'bg-gradient-to-br from-sky-500 to-cyan-500'} flex items-center justify-center`} style={{ clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}>
                <span className="text-white font-bold text-lg sm:text-xl absolute top-2 left-2 sm:top-3 sm:left-3">{card.rank}</span>
              </div>

              <div className="p-5 sm:p-6 md:p-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
                  {/* カード画像 */}
                  <div className="lg:col-span-3">
                    <div className="relative">
                      <img
                        src={card.image}
                        alt={card.name}
                        className="w-full h-40 sm:h-48 object-cover rounded-xl shadow-md group-hover:scale-105 transition-transform duration-300"
                      />
                      <span className={`absolute top-2 right-2 bg-gradient-to-r ${card.badgeColor} text-white px-2 py-1 rounded-full text-xs font-bold shadow-md`}>
                        {card.badge}
                      </span>
                    </div>
                  </div>

                  {/* カード情報 */}
                  <div className="lg:col-span-6">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2 pl-8 sm:pl-0">
                      {card.name}
                    </h3>
                    <p className="text-sky-600 font-medium text-sm sm:text-base mb-4">
                      {card.highlight}
                    </p>

                    {/* スペック */}
                    <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4">
                      <div className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs text-gray-500 mb-1">年会費</p>
                        <p className="font-bold text-gray-900 text-sm sm:text-base">{card.annualFee}</p>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs text-gray-500 mb-1">還元率</p>
                        <p className="font-bold text-gray-900 text-sm sm:text-base">{card.returnRate}</p>
                      </div>
                      <div className="bg-sky-50 rounded-lg p-3">
                        <p className="text-xs text-sky-600 mb-1">海外旅行保険</p>
                        <p className="font-bold text-sky-700 text-sm sm:text-base">{card.travelInsurance}</p>
                      </div>
                      <div className="bg-amber-50 rounded-lg p-3">
                        <p className="text-xs text-amber-600 mb-1">空港ラウンジ</p>
                        <p className="font-bold text-amber-700 text-sm sm:text-base">{card.lounge}</p>
                      </div>
                    </div>

                    {/* 特徴タグ */}
                    <div className="flex flex-wrap gap-2">
                      {card.features.map((feature, idx) => (
                        <span
                          key={idx}
                          className="bg-gray-100 text-gray-700 px-2 py-1 rounded-md text-xs"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="lg:col-span-3 flex flex-col justify-center gap-3">
                    <a
                      href={card.href}
                      className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white font-bold px-6 py-3 rounded-xl transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap text-sm sm:text-base"
                    >
                      詳細を見る
                      <i className="ri-arrow-right-line"></i>
                    </a>
                    <a
                      href="#"
                      className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-6 py-3 rounded-xl transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap text-sm sm:text-base"
                    >
                      公式サイトへ
                      <i className="ri-external-link-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
